import axios from 'axios';
import ReactPaginate from 'react-paginate'
import React, { Component, useState } from 'react'
import "../../services/ApiRest";
import swal from 'sweetalert';
import { ApiUrl } from '../../services/ApiRest';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';


const urlListarSedes = ApiUrl + "listarsedes" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarestud = ApiUrl + "listestudmatriperiodcoo" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarAsignaturas = ApiUrl + "listasignmatrireport" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListPeriodos = ApiUrl + "listperiodostodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarCarreras = ApiUrl + "listarcarreras" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlInfoCarrera = ApiUrl + "infocarrselect" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

let listaauxiliar = [];
const itemsPerPage = 10;

export default class MatriculasPeriodCoord extends Component {

    constructor(props) {
        super(props)

        this.state = {
            carrera: [],
            sedes: [],
            estud: [],
            listaniveles: [],
            EstudianteBackup: [],
            textBuscar: "",
            descripCarrE: "",
            estado: "",
            listaperiodos: [],
            listasignaturas: [],
            listaEstCoord: [],
            //variables para paginación
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
        }
        this.handleChange = this.handleChange.bind(this);
        this.escFunction = this.escFunction.bind(this);
    }
    escFunction(event) {
        if (event.key === "Escape") {
            this.setState({ modalReportAsignatutasEst: false });
        }
    }
    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ estado: "" });

    }

    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, true);
        axios
            .get(urlListPeriodos)
            .then(response => {
                const listaperiodos = response.data.data;
                const cant = listaperiodos.length;
                if (cant != 0) {
                    this.setState({ listaperiodos });
                }
            })


        axios.get(urlListarSedes)
            .then(respuesta => {
                const sedes = respuesta.data;
                this.setState({ sedes });
            })
        //Listar las carreras
        axios.get(urlListarCarreras)
            .then(res => {
                const carrera = res.data;
                this.setState({ carrera });
            })
    }
    //BUSQUEDA......
    filter(event) {
        console.log(event.target.value);
        //obtener datos de buscar
        var text = event.target.value
        //obtener datos del array
        const data = this.state.estud
        var newData = data.filter(function (item) {
            //variable del objeto
            const itemDataPrimerApell = item.primer_apellido_estudiante.toUpperCase()
            const itemDataPrimerNom = item.primer_nombre_estudiante.toUpperCase()
            const itemDataCedula = item.numero_identificacion_estudiante.toUpperCase()
            const campo = itemDataPrimerApell + " " + itemDataPrimerNom + " " + itemDataCedula;
            //variable del buscador
            const textData = text.toUpperCase()
            //return itemData.indexOf(textData)> -1
            return campo.indexOf(textData) > -1
        })
        if (text == "") {
            newData = this.state.EstudianteBackup;
        }
        this.setState({
            currentItems: newData,
            textBuscar: text,
        })
    }
    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ EstudianteBackup: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
    }

    //Mostrar las asignaturas matriculadas de un estudiante
    mostrarAsignaturasMat = (registro) => {
        axios.post(urlListarAsignaturas, {
            idEstudiante: registro.id_estudiante,
            idPeriodo: this.state.idPeriodoSelect,
            idCarrera: this.state.idCarrera
        })
            .then(response => {
                if (response.data.success === true) {
                    const listasignaturas = response.data.data;
                    this.setState({ descripCarrE: listasignaturas[0].descripcion_carrera });
                    this.setState({ listasignaturas });
                }
            })
            .catch(error => {
                this.setState({ error: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
        this.setState({ modalReportAsignatutasEst: true, form1: registro });
    }

    ocultarModalReportAsignaturas = () => {
        this.setState({ modalReportAsignatutasEst: false });
    }
    //Estudiantes matriculados en una coordinación
    handleChangeCoordinacion = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        axios.post(urlListarestud, {
            idPeriodoS: this.state.idPeriodoSelect,
            idCoordinacionS: this.state.idCoord,
            idCarreraS: this.state.idCarrera,
            idCicloNivelS: this.state.nivelEstu
        })
            .then(respuesta => {

                if (respuesta.data.success == true) {

                    this.setState({ listaEstCoord: respuesta.data.data });
                    listaauxiliar = respuesta.data.data;
                    const estud = respuesta.data.data;
                    this.setState((state) => {
                        return { estud: estud }
                    }
                    );
                    const EstudianteBackup = estud;

                    this.setState((state) => {
                        return { EstudianteBackup: EstudianteBackup }
                    });
                    //PAGINACION
                    this.state.itemOffset = 0;
                    const endOffset = this.state.itemOffset + itemsPerPage;
                    this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ EstudianteBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                    this.setState((state) => {
                        return { itemOffset: state.itemOffset + endOffset }
                    });
                    //FIN  D DE LA PAGINACION
                } else {

                    this.setState({ listaEstCoord: [] });
                    this.setState({ currentItems: null });
                    this.setState({ error: "No existe estudiantes" });
                    swal({
                        text: "¡No existe estudiantes matriculados en la coordinación seleccionada!",
                        icon: "info",
                        button: "Aceptar",
                    });
                }
            })
    }

    handleChangeSelectNivel = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        axios
            .post(urlInfoCarrera, {
                idCarreraS: this.state.idCarrera
            })
            .then(response => {
                const codigocarrest = response.data.objcarrea[0].id_carrera;
                const descripcarrest = response.data.objcarrea[0].descripcion_carrera;
                const nivelcarrest = response.data.objcarrea[0].num_niveles;
                this.setState({ codigoCarrE: codigocarrest });
                this.setState({ descripCarrE: descripcarrest });
                this.setState({ numnivelE: nivelcarrest });
                let listaniveles1 = []
                for (let i = 1; i <= nivelcarrest; i++) {
                    let fila = {
                        codnivel: i,
                        valor: i
                    };
                    listaniveles1.push(fila);
                }
                this.setState({ listaniveles: listaniveles1 });
            })
    }
    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card p-3 mb-2 bg-white rounded-4 shadow-sm border-0">
                    <div className="back-istmas d-flex align-items-center">
                        <i className="far fa-sticky-note me-2"></i>
                        <b className="mb-0 fw-semibold">Matrículas por Coordinación</b>
                    </div>

                    <div className="p-3 rounded-3">
                        <div className="row g-3 mb-3">
                            {/* Buscar */}
                            <div className="col-12 col-md-4">
                                <label className="form-label text-azul small">
                                    <i className="fa fa-search me-1"></i> Buscar
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={this.state.text}
                                    placeholder="Buscar..."
                                    onChange={(text) => this.filter(text)}
                                />
                            </div>

                            {/* Período */}
                            <div className="col-12 col-md-4">
                                <label className="form-label text-azul small">
                                    <i className="fa fa-calendar me-1"></i> Período
                                </label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idPeriodoSelect"
                                    value={this.state.idPeriodoSelect}
                                    onChange={this.handleChange}
                                >
                                    <option value="undefined" selected disabled>Seleccione el período</option>
                                    {this.state.listaperiodos.map(periodo => (
                                        <option
                                            key={periodo.id_periodo_academico}
                                            value={periodo.id_periodo_academico}
                                        >
                                            {periodo.descripcion_periodo_academico}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Carrera */}
                            <div className="col-12 col-md-4">
                                <label className="form-label text-azul small">
                                    Carrera
                                </label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idCarrera"
                                    value={this.state.idCarrera}
                                    onChange={this.handleChangeSelectNivel}
                                >
                                    <option value="undefined" selected disabled>Seleccione una carrera</option>
                                    {this.state.carrera.map(person => (
                                        <option key={person.id_carrera} value={person.id_carrera}>
                                            {person.descripcion_carrera}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Nivel */}
                            <div className="col-12 col-md-4">
                                <label className="form-label text-azul small">
                                    Nivel
                                </label>
                                <select
                                    className="form-select form-select-sm"
                                    id="nivelEstu"
                                    name="nivelEstu"
                                    value={this.state.nivelEstu}
                                    onChange={this.handleChange}
                                >
                                    <option value="undefined" selected disabled>Seleccione un nivel</option>
                                    {this.state.listaniveles.map(person => (
                                        <option key={person.codnivel} value={person.codnivel}>
                                            {person.valor}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Coordinación */}
                            <div className="col-12 col-md-4">
                                <label className="form-label text-azul small">
                                    Coordinación
                                </label>
                                <select
                                    className="form-select form-select-sm"
                                    id="idCoord"
                                    name="idCoord"
                                    value={this.state.idCoord}
                                    onChange={this.handleChangeCoordinacion}
                                >
                                    <option value="undefined" selected disabled>Seleccione una sede</option>
                                    {this.state.sedes.map(person => (
                                        <option key={person.id_sede} value={person.id_sede}>
                                            {person.descripcion_sede}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="row animate__animated animate__fadeIn">
                            <div className="col-12">
                                <h6 className="fw-bold text-center mb-3 text-azul small">ESTUDIANTE</h6>

                                {/* Tabla principal */}
                                <div className="table-responsive">
                                    <table className="table table-sm table-hover align-middle small">
                                        <thead className="table-light">
                                            <tr>
                                                <th className="text-azul">Cédula</th>
                                                <th className="text-azul">Primer Apellido</th>
                                                <th className="text-azul">Segundo Apellido</th>
                                                <th className="text-azul">Primer Nombre</th>
                                                <th className="text-azul">Segundo Nombre</th>
                                                <th className="text-azul">Asignaturas</th>
                                            </tr>
                                        </thead>
                                        <tbody className="small text-azul">
                                            {this.state.currentItems?.map(consola => (
                                                <tr className="list-afiliados" key={consola.id_estudiante}>
                                                    <td>{consola.numero_identificacion_estudiante}</td>
                                                    <td>{consola.primer_apellido_estudiante}</td>
                                                    <td>{consola.segundo_apellido_estudiante}</td>
                                                    <td>{consola.primer_nombre_estudiante}</td>
                                                    <td>{consola.segundo_nombre_estudiante}</td>
                                                    <td>
                                                        <button
                                                            className="btn btn-sm btn-outline-primary"
                                                            onClick={() => this.mostrarAsignaturasMat(consola)}
                                                        >
                                                            <i className="fas fa-clipboard-list"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Tabla de coordinación oculta */}
                                <div className="table-responsive mt-2" hidden>
                                    <table id="tablalistcoord" className="table table-sm table-hover align-middle small">
                                        <thead className="table-light">
                                            <tr>
                                                <th className="text-azul">Cédula</th>
                                                <th className="text-azul">Primer Apellido</th>
                                                <th className="text-azul">Segundo Apellido</th>
                                                <th className="text-azul">Primer Nombre</th>
                                                <th className="text-azul">Segundo Nombre</th>
                                                <th className="text-azul">Coordinación</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-azul">
                                            {this.state.listaEstCoord.map(consola => (
                                                <tr className="list-afiliados" key={consola.id_estudiante}>
                                                    <td>{consola.numero_identificacion_estudiante}</td>
                                                    <td>{consola.primer_apellido_estudiante}</td>
                                                    <td>{consola.segundo_apellido_estudiante}</td>
                                                    <td>{consola.primer_nombre_estudiante}</td>
                                                    <td>{consola.segundo_nombre_estudiante}</td>
                                                    <td>{consola.descripcion_sede}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Modal de asignaturas */}
                                <Modal size="lg" isOpen={this.state.modalReportAsignatutasEst}>
                                    <ModalHeader>
                                        <div className="alert alert-success small mb-0 text-azul">
                                            {this.state.descripCarrE}
                                        </div>
                                    </ModalHeader>
                                    <ModalBody>
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-sm small">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th className="text-azul">Código</th>
                                                        <th className="text-azul">Asignatura</th>
                                                        <th className="text-azul">Nivel</th>
                                                        <th className="text-azul">No Matrícula</th>
                                                        <th className="text-azul">Paralelo</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-azul">
                                                    {this.state.listasignaturas.map(item => (
                                                        <tr key={item.id_asignatura}>
                                                            <td>{item.codigo_asignatura}</td>
                                                            <td>{item.descripcion_asignatura}</td>
                                                            <td>{item.nivel_asignatura}</td>
                                                            <td>{item.tipo_matricula_asignatura}</td>
                                                            <td>
                                                                {(() => {
                                                                    switch (item.paralelo) {
                                                                        case 1: return "A";
                                                                        case 2: return "B";
                                                                        case 3: return "C";
                                                                        case 4: return "D";
                                                                        case 5: return "E";
                                                                        case 6: return "A1";
                                                                        case 7: return "B1";
                                                                        case 8: return "C1";
                                                                        case 9: return "D1";
                                                                        case 10: return "F";
                                                                        case 11: return "G";
                                                                        case 12: return "H";
                                                                        case 13: return "I";
                                                                        default: return "";
                                                                    }
                                                                })()}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </ModalBody>
                                    <ModalFooter>
                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            onClick={this.ocultarModalReportAsignaturas}
                                        >
                                            Salir
                                        </button>
                                    </ModalFooter>
                                </Modal>

                                {/* Botón de exportar a Excel centrado */}
                                <div className="text-center mt-3">
                                    <ReactHTMLTableToExcel
                                        id="botonExportarExcel"
                                        className="btn btn-sm btn-success"
                                        table="tablalistcoord"
                                        filename="matriculascoord"
                                        sheet="Coordinación"
                                        buttonText="Exportar a Excel"
                                    />
                                </div>

                                {/* Paginador */}
                                <div className="d-flex justify-content-center mt-3">
                                    <ReactPaginate
                                        nextLabel=">"
                                        previousLabel="<"
                                        onPageChange={this.handlePageClick}
                                        pageRangeDisplayed={5}
                                        pageCount={this.state.pageCount}
                                        marginPagesDisplayed={2}
                                        containerClassName="pagination pagination-sm-custom"
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        breakLabel="..."
                                        breakClassName="page-item"
                                        breakLinkClassName="page-link"
                                        activeClassName="active"
                                        renderOnZeroPageCount={null}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                </div>
            </div>
        )
    }
}
